<template>
  <div class="container">
    <div v-bind:class="loader">
      <div class="row">
        <div class="col-12 text-center mt-5">
          <a href="" class="btn btn-link btn-lg" style="font-size: 30px">
            <i class="fas fa-spinner"></i>
          </a>
        </div>
      </div>
    </div>

    <div v-bind:class="result">
      <div class="row justify-content-center">
        <div class="col-lg-5 mt-5">
          <div class="o-hidden border-0 shadow-lg my-5">
            <div class="card-body p-0">
              <!-- Nested Row within Card Body -->
              <div class="row justify-content-center">
                <div class="col-12 text-center mt-3">
                  <img src="../../../../static/img/logo.png" class="img-fluid mx-auto" alt="" style="height: 150px" />
                </div>
                <div class="col-10">
                  <div class="px-5 pb-5 pt-3">
                    <div class="text-center">
                      <h1 class="h4 text-gray-900 mb-4">Iniciar Sesión</h1>
                    </div>
                    <form class="user" v-on:submit.prevent="Login">
                      <button
                        type="submit"
                        style="background-color: #b500ce; border-color: #b500ce"
                        class="btn btn-secondary btn-user btn-block"
                      >
                        Entrar con msal
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center login-version-wrapper">
      <div class="version-container">
        <div class="version-text text-gray-900">{{ app_version }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import GeneralMixin from "@/components/mixins/General";

export default {
  mixins: [GeneralMixin],
  data() {
    return {
      tecnosis_login_url: "auth/tecnosis/login",
      teleperformance_login_url: "auth/teleperformance/login",
      email: "",
      password: "",
      idagente: "",
      loader: "",
      tipo: 2,
      result: "d-none",
    };
  },
  methods: {
    Cargando() {
      this.loader = "";
      this.result = "d-none";
    },
    Listo() {
      var that = this;
      $(document).ready(function () {
        that.loader = "d-none";
        that.result = "";
      });
      this.Iniciar_Sesion();
    },
    Iniciar_Sesion: function () {
      if (this.$msal.isAuthenticated()) {
        this.Seleccionar_Modo_Del_Cliente().then((modo) => {
          this.Autenticar_Usuario(modo);
        });
      } else {
      }
    },
    Login() {
      if (this.$msal.isAuthenticated()) {
        this.Seleccionar_Modo_Del_Cliente().then((modo) => {
          this.Autenticar_Usuario(modo);
        });
      } else {
        this.$msal.signIn();
      }
    },
    Salir: function () {
      this.$msal.signOut();
    },
    Seleccionar_Modo_Del_Cliente: function () {
      return swal("Seleccione una opción", {
        className: "login-swa-client-mode-modal",
        buttons: {
          domestic: {
            text: "R3",
            value: "domestic",
          },
          nearShore: {
            text: "R7",
            value: "near-shore",
          },
        },
      });
    },
    Autenticar_Usuario(modo) {
      this.Cargando();
      let password = "";
      let ruta = this.tecnosis_login_url;
      if (this.menu.servidor != "Tecnosis") {
        password = this.password;
        ruta = this.teleperformance_login_url;
      } else {
        password = md5(this.password);
      }
      this.$http
        .post(
          this.get_ptc_url(ruta),
          {
            tipo: this.tipo,
            idagente: this.idagente,
            tokenfcm: this.$store.state.menu.tokenfcm,
            password: password,
            modo,
          },
          {
            headers: this.get_request_headers({
              token: this.menu.tokenGenerico,
              accesstoken: localStorage.tokenmsal,
            }),
          }
        )
        .then((res) => res.json())
        .then((rej) => {
          this.Actualizar_TokenRefresh(rej);
          if (rej.idagente == true) {
            if (rej.password == true) {
              return this.$http
                .post(
                  this.get_ptc_url("token"),
                  {
                    data: {
                      tipo: "WEB",
                    },
                  },
                  {
                    headers: this.get_request_headers({
                      token: rej.jwt,
                      accesstoken: localStorage.getItem("tokenmsal"),
                    }),
                  }
                )
                .then((rjr) => rjr.json())
                .then((rjt) => {
                  const nt = _.get(rjt, "token", null);
                  if (nt) {
                    const usuario_datos = this.get_token_contents(nt);
                    this.Asignar_Interceptor_Token({ token: nt });
                    this.Actualizar_Usuario({ usuario: usuario_datos.data });
                    this.Actualizar_Token(nt);
                    this.$router.push({ name: "Menu" });
                  }
                });
            } else {
              this.Listo();
              swal("Contraseña Incorrecta", "Favor de intentar de nuevo", "error");
            }
          } else {
            this.Listo();
            swal("Usuario no Registrado", "Favor de intentar de nuevo", "error");
          }
        })
        .catch((e) => {
          if (e.body.code == "MSAL_TOKEN_IS_NOT_VALID") {
            this.$msal.signOut();
          }
          swal("Problemas para conectarse", "Favor de revisar su conexión a internet", "error");
          this.Listo();
        });
    },
    Validar_Permisos(token) {
      var that = this;
      this.$store.dispatch("Definir_Opciones_Menu_Lateral").then((data) => {
        that.Continuar_Menu(token);
      });
    },
    Continuar_Menu(token) {
      var that = this;
      this.$router.push({ name: "Menu" });
    },
    ...mapActions(["Actualizar_Usuario", "Asignar_Interceptor_Token", "Actualizar_TokenRefresh", "Actualizar_Token"]),
  },
  computed: {
    ...mapState({
      app_version: (state) => state.config.app_version,
    }),
    menu() {
      return this.$store.getters.getMenu;
    },
  },
  mounted() {
    this.Listo();
  },
};
</script>

<style>
.login-swa-client-mode-modal .swal-footer {
  text-align: center !important;
}

.login-version-wrapper {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 25px;
}
</style>
